module.exports = __webpack_public_path__ + "static/media/contact-home-care-img.d5ed0c06.jpg";